<style lang="less">
.myAward {
  .cl-danger {
    color: #d0021b;
  }
  &__bar {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 1rem;
    text-align: center;
    border: 1px dotted #ddd;
    border-width: 1px 0;
    font-size: 0.24rem;
    color: #7b7b7b;
  }
  &__info {
    padding: 0.3rem 0 0 0.3rem;
    text-align: left;
  }
  &__btn {
    position: absolute;
    top: 0.2rem;
    right: 0.1rem;
    width: 1.9rem;
    .btnGoSoft {
      display: block;
      background-image: linear-gradient(270deg, #c7a862 0%, #f8efbc 100%);
      box-shadow: inset 0 0.03rem 0.06rem 0 rgba(248, 247, 242, 0.5);
      border-radius: 0.36rem;
      color: #000;
      height: 0.56rem;
      line-height: 0.56rem;
      padding: 0 0.4rem;
      &:visited {
        color: #000;
      }
    }
  }
}
</style>
<template>
  <div class="myAward">
    <div class="myAward__bar">
      <div class="myAward__info">
        我的奖励：已发放<span class="cl-danger">{{ myAward.doneDays }}</span
        >天，待发放<span class="cl-danger">{{ myAward.pendDays }}</span
        >天
      </div>
      <div class="myAward__btn">
        <a class="btnGoSoft" href="/award2020/dianjin/list">我的软件</a>
      </div>
    </div>
    <div v-if="myUid > 0" class="daMain__goMy">
      <router-link v-if="!isLeader" to="/">我也要发起助力&gt;&gt;</router-link>
      <router-link
        v-else-if="inviteInfo && inviteInfo.uid > 0"
        :to="`/da?uid=${inviteInfo.uid}`"
        >我参与过的助力&gt;&gt;</router-link
      >
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  name: 'app-my-award',
  props: [],
  computed: {
    ...mapState('laxin/da', ['inviteInfo']),
    ...mapGetters('account', ['myUid']),
    ...mapGetters('laxin/da', ['isLeader']),
    ...mapGetters('laxin', ['myAward'])
  },
  methods: {
    ...mapActions('laxin', ['loadMyAwards']),
    async load() {
      await this.loadMyAwards()
    }
  },
  mounted() {
    this.load()
  }
}
</script>
